<template>
  <div v-if="user && artist_role">
    <ArtistDashboard />
  </div>
  <div v-else-if="user && label_role">
    <LabelDashboard />
  </div>
  <div v-else-if="user && content_role">
    <ContentHome />
  </div>
  <div v-else-if="user">
    <AdminDashboard />
  </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ArtistDashboard from '@/modules/artist/dashboard/views/Index.vue'
import LabelDashboard from '@/modules/label/dashboard/views/Index.vue'
import ContentHome from '@/modules/content/home/views/Index.vue'
import AdminDashboard from '@/modules/admin/dashboard/views/Index.vue'

export default {
  components: {
    AdminDashboard,
    ArtistDashboard,
    LabelDashboard,
    ContentHome
  },

  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['label_role', 'artist_role', 'content_role'])
  }
}
</script>
